module.exports = __webpack_public_path__ + "static/media/About.4167bc17.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Support/images/About.svg
 ** module id = 1318
 ** module chunks = 0
 **/